/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Requests_Desc_UserInputs */



/**
* | output |
* | --- |
* | "Daily trend of this user's API requests" |
*
* @param {Dashboard_Requests_Desc_UserInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_requests_desc_user = /** @type {((inputs?: Dashboard_Requests_Desc_UserInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Requests_Desc_UserInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Täglicher Trend der API-Anfragen dieses Benutzers")
	return /** @type {LocalizedString} */ ("Daily trend of this user's API requests")
});